import {useEffect} from 'react'
import * as Sentry from '@sentry/react'

export const logModuleView = (moduleName: string) => {
    if (!moduleName) {
        return
    }
    Sentry.captureMessage(`Viewed Module: ${moduleName}`, 'info')
}

export const useModuleViewTracking = (moduleName: string) => {
    useEffect(() => {
        logModuleView(moduleName)
    }, [moduleName])
}
